import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotasDeDocumentosFiscais: RouteConfig[] = [
	{
		path: 'documentos-fiscais',
		name: 'Documentos Fiscais',
		components: {
			default: () =>
				import('@/views/application/documentos-fiscais/TelaDeDocumentosFiscais.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'documentos-fiscais' as TipoDeRecurso,
		},
	},
]

export default rotasDeDocumentosFiscais